var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ActiveHost === null)?_c('div',[_vm._v("Loading...")]):_c(_vm.ActiveComponent,{tag:"component"})}
var staticRenderFns = []

export { render, staticRenderFns }